import { callPost } from '@/api/fetcher';
import { MetricsQueryRequest, MetricsQueryResponse } from '@/shared/types/metricsQuery';

export const endpoints = Object.freeze({ query: '/www/api/v1/metrics/query' });

export const API = Object.freeze({
  query: async (body: MetricsQueryRequest): Promise<MetricsQueryResponse> =>
    callPost(endpoints.query, body),
});
